export const northDistricts = [
  "Te Tai Tokerau | Northland ",
  "Waitematā",
  "Te Toka Tumai | Auckland ",
  "Counties Manukau",
  "Waikato",
  "Lakes",
  "Hauora a Toi | Bay of Plenty ",
  "Tairāwhiti | Gisborne",
  "Taranaki",
  "Whanganui",
  "Capital, Coast and Hutt Valley",
  "Te Matau a Māui | Hawke's Bay ",
  "Te Pae Hauora o Ruahine o Tararua | MidCentral",
  "Wairarapa",
];

export const southDistricts = [
  "Nelson Marlborough",
  "Waitaha | Canterbury ",
  "South Canterbury",
  "Te Tai o Poutini | West Coast ",
  "Southern",
];

// Full list of roles (do not use directly in UI/state machine)
export const roles = [
  "RMO",
  "Consultant (SMO)",
  "General Practitioner (GP)",
  "GP Trainee",
  "Nurse Practitioner or Prescriber",
  "Nurse",
  "Midwife",
  "Dentist",
  "Pharmacist",
  "Other",
  "Student",
  "ACA Staff",
];

/**
 * Returns the roles array, with 'ACA Staff' only included if not in production.
 * Use this in the UI and state machine to ensure ACA Staff is test-only.
 *
 * Uses VITE_SANITY_PERSPECTIVE to determine environment:
 * - 'previewDrafts' = staging/development (includes ACA Staff)
 * - 'published' = production (excludes ACA Staff)
 */
export function getRoles(): string[] {
  const perspective = import.meta.env.VITE_SANITY_PERSPECTIVE;

  // Production uses 'published' perspective, staging uses 'previewDrafts'
  const isProduction = perspective === 'published';

  // Filter roles based on environment
  const filteredRoles = isProduction
    ? roles.filter((role) => role !== "ACA Staff")
    : roles;

  return filteredRoles;
}

// For convenience, export a filtered constant based on current env
export const rolesFiltered = getRoles();

export const practiceAreas = [
  "Community Care",
  "Emergency Medicine",
  "Hospital Medicine",
  "Hospital Surgery",
  "Anaesthetics",
  "Paediatric Hospital Care",
  "Rural Hospital Care",
  "Other",
];

export const acaStaff = [
  "Sharon",
  "Eamon",
  "Max",
  "Mark",
  "Steve",
  "Sarah M",
  "Emma",
  "Lily",
  "Karen",
  "Tom",
];